/**
 * 🚨 This file is generated by scripts/zendesk.ts. Don't modify it manually!
 */

export const increaseCreditLimitCustomFieldsNZ = {
  Status: { prod: "NA", nonProd: 360010704517 },
  Group: { prod: "NA", nonProd: 360010704577 },
  Assignee: { prod: "NA", nonProd: 360010704597 },
  Subject: { prod: "NA", nonProd: 360010704477 },
  Description: { prod: "NA", nonProd: 360010704497 },
  "Customers first name": { prod: "NA", nonProd: 360010706397 },
  "Surname  (as it appears on ID)": { prod: "NA", nonProd: 360010709557 },
  DOB: { prod: "NA", nonProd: 360010707057 },
  "Last 4 digits": { prod: "NA", nonProd: 360010709017 },
  "Mobile Number": { prod: "NA", nonProd: 360010707337 },
  "Card type NZ": { prod: "NA", nonProd: 360010669158 },
  "New Limit": { prod: "NA", nonProd: 360010708077 },
  "Personal Relationship Status": { prod: "NA", nonProd: 1900000807313 },
  Dependants: { prod: "NA", nonProd: 360010665998 },
  "Total Income": { prod: "NA", nonProd: 360010710397 },
  "Payment Frequency WFM - 1": { prod: "NA", nonProd: 360025225338 },
  "Total Limit On Credit Card": { prod: "NA", nonProd: 1900000815453 },
  "Payment Frequency WFM": { prod: "NA", nonProd: 360025389317 },
  "Expense: Other Loans": { prod: "NA", nonProd: 1900000815493 },
  "Payment Frequency WFM - 2": { prod: "NA", nonProd: 1900000815653 },
  "Preferred Contact Method": { prod: "NA", nonProd: 360010707857 },
  "Privacy Acknowledgement": { prod: "NA", nonProd: 360010666398 },
  "Time spent last update (sec)": { prod: "NA", nonProd: 360010665818 },
  "Total time spent (sec)": { prod: "NA", nonProd: 360010669938 },
  "Total Amount Owing - NZ CLI": { prod: 360026053977, nonProd: 1900001511273 },
  "Loan Commitments - NZ CLI": { prod: 360025881558, nonProd: 360026054777 },
  "Savings for Lump Sum - NZ CLI": {
    prod: 360025881538,
    nonProd: 360026054757,
  },
  "Lump sum payment - NZ CLI": { prod: 360026053937, nonProd: 1900001510973 },
  "Total expenses monthly - NZ CLI": {
    prod: 360025881518,
    nonProd: 360026054737,
  },
  "Generic Additional Expense - NZ CLI": {
    prod: 1900001509413,
    nonProd: 360026054717,
  },
  "Fitness/Medical - NZ CLI": { prod: 360026053917, nonProd: 360026054557 },
  "Education/Childcare - NZ CLI": { prod: 360026053897, nonProd: 360026054537 },
  "Transport - NZ CLI": { prod: 360026053877, nonProd: 360025882558 },
  "General Insurance - NZ CLI": { prod: 360025881358, nonProd: 360025882538 },
  "Personal Insurance - NZ CLI": { prod: 360025881338, nonProd: 1900001510953 },
  "Food/Groceries/Entertainment - NZ CLI": {
    prod: 360025881178,
    nonProd: 1900001510933,
  },
  "Expenses Change - NZ CLI": { prod: 1900001509393, nonProd: 360026054517 },
  "Utilities & Expenses - NZ CLI": {
    prod: 360026053697,
    nonProd: 360026054357,
  },
  "Property Rates - NZ CLI": { prod: 1900001509233, nonProd: 360025882498 },
  "Secondary Property Mortgage/Rent/Board - NZ CLI": {
    prod: 1900001509213,
    nonProd: 360025882458,
  },
  "Housing Costs Changed - NZ CLI": {
    prod: 360025880598,
    nonProd: 360025882438,
  },
  "Revolving Mortgage - NZ CLI": { prod: 360026053537, nonProd: 360026054337 },
  "Household Expenses - NZ CLI": { prod: 1900001508913, nonProd: 360025882278 },
  "Income Reduction - NZ CLI": { prod: 1900001508633, nonProd: 1900001510853 },
  "Total Monthly Income - NZ CLI": {
    prod: 1900001508613,
    nonProd: 360025882258,
  },
  "Additional Employment Status - NZ CLI": {
    prod: 1900001508593,
    nonProd: 1900001510833,
  },
  "Additional Income Frequency": { prod: 360026053357, nonProd: 360026054317 },
  "Additional Income - NZ CLI": { prod: 1900001508533, nonProd: 360025882098 },
  "Employment Status - NZ CLI": { prod: 360025880158, nonProd: 360025882078 },
} as const;

export const frequencyOptionsNz = {
  "Payment Frequency WFM - 1": {
    weekly: { prod: "pay_freq_weekly", nonProd: "pay_freq_weekly" },
    fortnightly: {
      prod: "pay_freq_fortnightly",
      nonProd: "pay_freq_fortnightly",
    },
    monthly: { prod: "pay_freq_monthly", nonProd: "pay_freq_monthly" },
  },
  "Payment Frequency WFM": {
    weekly: { prod: "payment_freq_weekly", nonProd: "pay_freq_weekly_0" },
    fortnightly: {
      prod: "payment_freq_fortnightly",
      nonProd: "pay_freq_fortnightly_0",
    },
    monthly: {
      prod: "payment_freq_monthly",
      nonProd: "pay_freq_2_monthly",
    },
  },
  "Payment Frequency WFM - 2": {
    weekly: { prod: "pay_freq_2_weekly", nonProd: "pay_freq_2_weekly" },
    fortnightly: {
      prod: "pay_freq_2_fortnightly",
      nonProd: "pay_freq_2_fortnightly",
    },
    monthly: { prod: "pay_freq_2_monthly", nonProd: "pay_freq_2_monthly" },
  },
};

// 360025882078 Employment Status - NZ CLI
export const employmentStatusOptions = {
  "Permanent full or part time": {
    prod: "permanent_full_or_part_time",
    nonProd: "permanent_full_or_part_time",
  },
  "Casual/Seasonal/Temporary": {
    prod: "casual/seasonal/temporary",
    nonProd: "casual/seasonal/temporary",
  },
  "Contractor – fixed term": {
    prod: "contractor_–_fixed_term",
    nonProd: "contractor_–_fixed_term",
  },
  "Contractor – self employed": {
    prod: "contractor_–_self_employed",
    nonProd: "contractor_–_self_employed",
  },
  "Self employed": {
    prod: "self_employed_nzcli",
    nonProd: "self_employed_nzcli",
  },
  "Superannuation/Government Benefit": {
    prod: "superannuation/government_benefit",
    nonProd: "superannuation/government_benefit",
  },
  ACC: { prod: "acc", nonProd: "acc" },
  "Rental income": { prod: "rental_income", nonProd: "rental_income" },
  Investment: { prod: "investment", nonProd: "investment" },
};

export const nzEmploymentStatusOptions = Object.keys(
  employmentStatusOptions,
).map((key) => ({ label: key, value: key }));

// 1900001510833 Additional Employment Status - NZ CLI
export const additionalEmploymentStatusOptions = {
  "Permanent full or part time": {
    prod: "permanent_full_or_part_time_nz_cli_additional",
    nonProd: "permanent_full_or_part_time_nz_cli",
  },
  "Casual/Seasonal/Temporary": {
    prod: "casual/seasonal/temporary_nz_cli_additional",
    nonProd: "casual/seasonal/temporary_nz_cli",
  },
  "Contractor – fixed term": {
    prod: "contractor_–_fixed_term_nz_cli_additional",
    nonProd: "contractor_–_fixed_term_nz_cli",
  },
  "Contractor – self employed": {
    prod: "contractor_–_self_employed_nz_cli_additional",
    nonProd: "contractor_–_self_employed_nz_cli",
  },
  "Self employed": {
    prod: "self_employed_nz_cli_additional",
    nonProd: "self_employed_nz_cli",
  },
  "Superannuation/Government Benefit": {
    prod: "superannuation/government_benefit_nz_cli_additional",
    nonProd: "superannuation/government_benefit_nz_cli",
  },
  ACC: { prod: "acc_nz_cli_additional", nonProd: "acc_nz_cli" },
  "Rental income": {
    prod: "rental_income_nz_cli_additional",
    nonProd: "rental_income_nz_cli",
  },
  Investment: {
    prod: "investment_nz_cli_additional",
    nonProd: "investment_nz_cli",
  },
};

export const nzAdditionalEmploymentStatusOptions = Object.keys(
  additionalEmploymentStatusOptions,
).map((key) => ({ label: key, value: key }));

// 360026054317  "Additional Income Frequency",
export const additionalIncomeFrequency = {
  weekly: { prod: "weekly_nzcli", nonProd: "weekly_nzcli" },
  fortnightly: { prod: "fortnightly_nzcli", nonProd: "fortnightly_nzcli" },
  monthly: { prod: "monthly_nzcli", nonProd: "monthly_nzcli" },
  quarterly: { prod: "quarterly_nzcli", nonProd: "quarterly_nzcli" },
};

// 1900001510853, "Income Reduction - NZ CLI",
export const incomeReduction = {
  yes: { prod: "yes_nz_cli", nonProd: "yes_nz_cli_2" },
  no: { prod: "no_nz_cli", nonProd: "no_nz_cli_2" },
};

// 360025882278, "Household Expenses - NZ CLI",
export const householdExpenses = {
  yes: { prod: "yes_nz_cli_2", nonProd: "yes_nz_cli_3" },
  no: { prod: "no_nz_cli_2", nonProd: "no_nz_cli_3" },
};

// 360025882438, "Housing Costs Changed - NZ CLI",
export const housingCostsChanged = {
  yes: { prod: "yes_nz_cli_3", nonProd: "yes_nz_cli_4" },
  no: { prod: "no_nz_cli_3", nonProd: "no_nz_cli_4" },
};

// 360026054517,"Expenses Change - NZ CLI",
export const expensesChange = {
  yes: { prod: "yes_nz_cli_4", nonProd: "yes_nz_cli_5" },
  no: { prod: "no_nz_cli_4", nonProd: "no_nz_cli_5" },
};

// 1900001510973, "Lump sum payment - NZ CLI",
export const lumpSumPayment = {
  yes: { prod: "yes_nz_cli_5", nonProd: "yes_nz_cli_6" },
  no: { prod: "no_nz_cli_5", nonProd: "no_nz_cli_6" },
};

// 360026054757,"Savings for Lump Sum - NZ CLI",
export const savingsForLumpSum = {
  yes: { prod: "yes_nz_cli_6", nonProd: "yes_nz_cli_7" },
  no: { prod: "no_nz_cli_6", nonProd: "no_nz_cli_7" },
};

// 360026054777, "Loan Commitments - NZ CLI",
export const loanCommitments = {
  yes: { prod: "yes_nz_cli_7", nonProd: "yes_nz_cli_8" },
  no: { prod: "no_nz_cli_7", nonProd: "no_nz_cli_8" },
};

// 360025389317, "Payment Frequency WFM",
export const paymentFrequencyWFM = {
  weekly: { prod: "payment_freq_weekly", nonProd: "pay_freq_weekly_0" },
  fortnightly: {
    prod: "payment_freq_fortnightly",
    nonProd: "pay_freq_fortnightly_0",
  },
  monthly: { prod: "payment_freq_monthly", nonProd: "pay_freq_monthly_0" },
};

// 1900000815653,  "Payment Frequency WFM - 2",
export const paymentFrequencyWFM2 = {
  weekly: { prod: "pay_freq_2_weekly", value: "pay_freq_2_weekly" },
  fortnightly: {
    prod: "pay_freq_2_fortnightly",
    value: "pay_freq_2_fortnightly",
  },
  monthly: { prod: "pay_freq_2_monthly", value: "pay_freq_2_monthly" },
};

// 360010707857, "Preferred Contact Method",
export const preferredContactMethod = {
  Phone: { prod: "phone", nonProd: "phone" },
  Email: { prod: "email_method", nonProd: "email_method" },
};
